/* eslint-disable no-console */
import { MobileAppEventBus } from '@hkm/features/app/events/bus';
import { mobileAppServiceWorkerUpdatedEvent } from '@hkm/features/app/events/predefined/serviceWorkerUpdated';
import { getServiceWorkerVersion } from '@hkm/features/app/features/manifest/bus/predefined/version';

const ONE_HOUR = 60 * 60 * 1000;

export const SERVICE_WORKER = '/serviceWorker.js';

let registered = false;

export async function register(): Promise<void> {
  if (registered || !('serviceWorker' in navigator)) return;
  registered = true;

  try {
    const reg = await navigator.serviceWorker.register(SERVICE_WORKER, {
      updateViaCache: 'none',
      scope: '/',
    });

    // Note: Store the current SW version to compare against new installations.
    let currentVersion = await getServiceWorkerVersion();

    setInterval(() => {
      reg.update().catch(() => undefined);
    }, ONE_HOUR);

    reg.addEventListener('updatefound', () => {
      const newWorker = reg.installing;
      if (!newWorker) return;

      newWorker.addEventListener('statechange', () => {
        if (newWorker.state !== 'activated') return;

        void getServiceWorkerVersion().then((newVersion) => {
          if (currentVersion && newVersion && currentVersion !== newVersion) {
            MobileAppEventBus.dispatch(mobileAppServiceWorkerUpdatedEvent());
          }
          currentVersion = newVersion;
        });
      });
    });
  } catch (error) {
    console.error(`[SW] ERROR: registered ${error}`);
  }
}
